<template>
  <section class="app-main">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </section>
</template>

<script>
import { Modal } from 'ant-design-vue'
import { microPhoneAuthCheck } from '@/utils/microPhoneAuthCheck'

export default {
  name: 'AppMain',
  data() {
    return {
    }
  },
  mounted() {
    if ('Notification' in window) { // 浏览器支持系统通知
      switch (Notification.permission) {
        case 'denied': // 被拒绝了，给个机会再次申请
          Modal.info({
            title: '您未允许HiLeia弹出通知，当您不在HiLeia页面时无法收到他人的呼叫提醒',
            content: h => h('div', [
              h('p', { style: { marginLeft: '-19px' } }, '您可以按照如下步骤设置通知来更好的使用HiLeia：'),
              h('ol', { style: { marginLeft: '-38px' } }, [
                h('li', '点击地址栏左侧“查看站点信息”按钮（小锁形状）'),
                h('li', '打开该网站的“网站设置”或“网站权限”'),
                h('li', '将通知权限设置为允许'),
              ])
            ])
          })
          break
        case 'default': // 需要时申请，不如现在就申请好
          Notification.requestPermission()
          break
        case 'granted': // happy
          break
      }
    }
    microPhoneAuthCheck(false)
  }
}
</script>

<style scoped lang="less">
.app-main {
  height: calc(100vh - 72px);
}
</style>
